export default "__VITE_ASSET__YIN2zhGp__"